/**
 * !infoNetz OWL – Einstieg. Jedes Modul prüft selbst, ob sein Markup auf der
 * Seite vorkommt. Ohne JavaScript bleibt alles benutzbar:
 *  - Themen / Menü / Lupe sind Links (Katalog bzw. Suche)
 *  - Akkordeons sind <details>
 *  - Tabs zeigen alle Panels untereinander
 *  - Lightbox-Links öffnen das Bild direkt
 *  - Formulare prüft der Browser (required), Fehler zeigt der Server
 *  - Drucken: print.css blendet Rahmen und Navigation aus, öffnet die Akkordeons
 */
import { initHeader } from './modules/header.js';
import { initTabs } from './modules/tabs.js';
import { initDeepLinks } from './modules/deeplink.js';
import { initLightbox } from './modules/lightbox.js';
import { initVideo } from './modules/video.js';
import { initToc } from './modules/toc.js';
import { initForm } from './modules/form.js';
import { initPrint } from './modules/print.js';

document.documentElement.classList.add('has-js');

initHeader();
initTabs();
initDeepLinks();
initLightbox();
initVideo();
initToc();
initForm();
initPrint();

/* Mobil eingeklappt starten (ohne JS bleibt alles offen):
   Footer-Linkmenüs und Bereiche im Katalog (außer dem per #anker angesprungenen) */
if (window.matchMedia('(max-width: 47.99em)').matches) {
  const target = location.hash.slice(1);
  document.querySelectorAll('.c-footer__group[open], .c-catalog__area[open]').forEach((d) => {
    if (d.id !== target) d.removeAttribute('open');
  });
}
